import React from "react";
import { Link } from "react-router-dom";
import { ShoppingCart, Users, Package, FileText } from "@phosphor-icons/react";

export default function QuickActions() {
    const actions = [
        {
            title: "New Sale",
            icon: ShoppingCart,
            iconColor: "text-green-600 dark:text-green-400",
            href: "/dashboard/sales/create",
        },
        {
            title: "Add Product",
            icon: Package,
            iconColor: "text-blue-600 dark:text-blue-400",
            href: "/dashboard/products/add-product",
        },
        {
            title: "Add Customer",
            icon: Users,
            iconColor: "text-amber-600 dark:text-amber-400",
            href: "/dashboard/customers",
        },
        {
            title: "Sales Report",
            icon: FileText,
            iconColor: "text-purple-600 dark:text-purple-400",
            href: "/dashboard/sales",
        }
    ];

    return (
        <div className="flex flex-wrap gap-2 mb-4">
            {actions.map((action, index) => (
                <Link to={action.href} key={index}>
                    <button className="inline-flex items-center gap-2 px-3 py-1.5 text-sm font-medium bg-white dark:bg-slate-800 border border-slate-200 dark:border-slate-700 text-slate-700 dark:text-slate-300 hover:bg-slate-50 dark:hover:bg-slate-700 hover:border-primary transition-colors">
                        <action.icon size={16} weight="bold" className={action.iconColor} />
                        {action.title}
                    </button>
                </Link>
            ))}
        </div>
    );
}
